.footer {
	border-top: 1px solid var(--ds-border, var(--adg3-color-N50));
	z-index: 99;
	position: fixed;
	width: 100%;
	bottom: 0;
}

.bottomBar {
	background: var(--ds-surface, var(--jpo-bg-default-color));
	display: flex;
	justify-content: flex-end;
	padding: var(--jpo-common-base-spacing);
}
